<template>
<Head>
  <title>Login | {{$page.props.appName}}</title>
  <meta name="description" :content="'Login for ' + $page.props.appName">

</Head>
  <div class="flex h-full">
    <div class="w-full flex items-center justify-center bg-black">
      <div class="xl:w-1/3 lg:w-1/3 md:1/2 sm:w-full w-full p-2  text-white rounded">
        <div class="text-center flex items-center justify-center">
        <img src="/images/pegasus-logo.png" class="h-52" alt="Pegasus Logo">

        </div>
        <form @submit.prevent="submit">
            <div v-if="$page.props.flash.message" class="bg-red-100 border-red-600 p-1 border-l-4 mt-2 font-semibold mb-3 text-black">
                <p class="ml-2">{{ $page.props.flash.message }}</p>
            </div>
            <label class="py-2 text-white " for="username">Username:</label>
            <input id="username" v-model="form.username" class="block border-b border-b-2 mb-2 p-2 w-full text-black" placeholder="Username"/>
            <label class="py-2 text-white" for="password">Password:</label>
            <input type="password" id="password" v-model="form.password" class="block border-b border-b-2 mb-2 p-2 w-full text-black"   placeholder="Password"/>
            <p class="text-center mt-3 text-white cursor-pointer" @click="forgottenPassword()">Forgotten your username or password?</p>
            <div>
            <button type="submit" class="button bg-white text-black font-bold float-right p-3 mt-2 rounded uppercase font"  :disabled="form.processing">Submit</button>

        </div>

      </form>

      </div>
    </div>

  </div>
</template>

<script>
import { reactive } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { Head } from '@inertiajs/inertia-vue3'

export default {
  setup () {
    const form = reactive({
      username: null,
      password: null,
    })

    function submit() {
      if(form.username != null && form.password != null){
        Inertia.post('/login', form)

      }else{ 
       alert("Please ensure you fill in all of the fields.");
      }
    }

    return { form, submit }
  },
  methods : {
    forgottenPassword() {
      alert("Please contact a manager for a password reset!");
    }
  },
  components : {
    Head
  }
}

</script>